import { Button, Form, Input, Loading } from '@gpstrackit/react-controls';
import { Grid, Paper } from '@mui/material';
import { useIntl } from 'react-intl';
//Logos
import logo from 'Assets/images/banner.png';
import google from 'Assets/images/google.svg';
import logoSecundary from 'Assets/images/verticalLogo.png';

//helpers
import {
    ErrorHandlerLogin
} from 'Core/data/Helpers';

import { useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";

//Actions
import {
    confirmUserRequest,
    confirmUserVerificateCodeRequest,
    clearRedux
} from 'Redux/actions';
//Notification
import {
    NotificationManager
} from "Components/Notifications";
import Alert from '@mui/material/Alert';

//Styles
import './confirmUser.scss';

const currentDomain = window.location.hostname === "localhost" ? `http://localhost:3000` : `https://${window.location.hostname}`;

const ConfirmUserView = () => {
    const { messages } = useIntl()
    //Ref
    const formRef = useRef();
    const queryParams = new URLSearchParams(location.search);

    const email = queryParams.get('email');
    const confirmationCode = queryParams.get('confirmationCode');
    const username = queryParams.get('username');
    const action = queryParams.get('action');

    const dispatch = useDispatch();
    const navigate = useNavigate();
    //Local States
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [confirmPasswordError, setConfirmPasswordError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    //Redux States
    const { loading, error, resultVerifyUser, resultVerifyCode } = useSelector(state => state.confirmUserRedux);

    const handleConfirmUser = () => {
        if (password !== confirmPassword) {
            setConfirmPasswordError(true);
            return;
        }
        dispatch(confirmUserRequest(username?.trim(), confirmationCode, password?.trim(), navigate, action));
    }

    useEffect(() => {
        dispatch(confirmUserVerificateCodeRequest({ username: username?.trim(), code: confirmationCode, type: action }));
        return () => {
            dispatch(clearRedux("CONFIRM_USER"));
        }
    }, [])

    useEffect(() => {
        if (resultVerifyUser) {
            dispatch(clearRedux("CONFIRM_USER"));
            if (resultVerifyUser?.success) {
                NotificationManager.success(action === 'forgotPassword' ? messages['confirm_user_confirm_password_sucess_message'] : messages['confirm_user_confirm_password_sucess_verify_message'],
                    action === "forgotPassword" ? messages['confirm_user_confirm_new_password'] : messages['confirm_user_confirm_user'], 5000);
                setPassword("");
                setConfirmPassword("");
                navigate('/login');
            } else if (!resultVerifyUser?.success) {
                setErrorMessage(resultVerifyUser.message);
                NotificationManager.error(resultVerifyUser.message, messages['confirm_user_error'], 5000);
            }

        }
        if (resultVerifyCode) {
            dispatch(clearRedux("CONFIRM_USER"));
            if (!resultVerifyCode?.isValid) {
                let message = "";
                if (resultVerifyCode?.registrationStatus === "Expired")
                    message = messages['confirm_user_expired_code']
                else
                    message = messages['confirm_user_invalid_code'];

                setErrorMessage(message);
                NotificationManager.error(message, messages['confirm_user_error'], 5000);
            }
        }
    }, [resultVerifyUser, resultVerifyCode])

    return (
        <div className='confirmUser-view'>
            {loading && <Loading overlay show />}
            <Grid>
                <Paper elevation={2} className="confirmUser-view-container-paper">
                    <div className="confirmUser-view-image">
                        <img src={logo} alt="fireSpot" />
                    </div>
                    <div className="confirmUser-view-form">
                        <Grid container justifyContent='center' style={{ marginBottom: 35 }}>
                            <Grid item xs={12} style={{ textAlign: 'center', margin: '20px 0' }}>
                                <img src={logoSecundary} style={{ width: 150 }} />
                            </Grid>
                            <div style={{ width: '100%', padding: '10px 10px 10px 10px', textAlign: 'center', fontSize: 14, fontWeight: 500 }}>
                                <span>{action === "forgotPassword" ? messages['confirm_user_confirm_new_password'] : messages['confirm_user_confirm_user']}</span>
                            </div>
                            <div style={{ width: '100%', padding: '0 30px' }}>
                                <Form
                                    ref={formRef}
                                    onValidSubmit={() => {
                                        handleConfirmUser();
                                    }}
                                >
                                    <div style={{ marginTop: 10, width: '315px' }}>
                                        <Input
                                            label={messages['confirm_user_username']}
                                            placeholder={messages['confirm_user_username']}
                                            type="text"
                                            value={username}
                                            requiredMessage={messages['confirm_user_required_filed']}
                                            disabled={true}

                                        />
                                    </div>
                                    <div style={{ marginTop: 10 }}>
                                        <Input
                                            required
                                            label={messages['confirm_user_password']}
                                            placeholder={messages['confirm_user_password']}
                                            type="password"
                                            value={password}
                                            onChange={(e) => {
                                                setPassword(e);
                                            }}
                                            requiredMessage={messages['confirm_user_required_filed']}
                                        />
                                    </div>
                                    <div style={{ marginTop: 10 }}>
                                        <Input
                                            required
                                            label={messages['confirm_user_confirm_password']}
                                            placeholder={messages['confirm_user_confirm_password']}
                                            type="password"
                                            value={confirmPassword}
                                            onChange={(e) => {
                                                setConfirmPassword(e);
                                            }}
                                            requiredMessage={messages['confirm_user_required_filed']}
                                        />
                                    </div>
                                    {
                                        error &&
                                        <p style={{ color: 'red', textAlign: 'center', fontSize: 12, marginTop: 10 }} >{ErrorHandlerLogin(error)}</p>
                                    }
                                    {
                                        confirmPasswordError &&
                                        <p style={{ color: 'red', textAlign: 'center', fontSize: 12, marginTop: 10 }} >{messages['confirm_user_confirm_password_error']}</p>
                                    }
                                    {
                                        errorMessage !== "" &&
                                        <p style={{ color: 'red', textAlign: 'center', fontSize: 12, marginTop: 10 }} >{errorMessage}</p>
                                    }
                                    <div style={{ marginTop: 10, textAlign: 'center' }}>
                                        <Button
                                            className="btn-dark-blue"
                                            type="button"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setConfirmPasswordError(false);
                                                setErrorMessage("");
                                                formRef.current.submit();
                                            }}
                                            style={{ width: '100%' }}
                                        >
                                            {messages['confirm_user_change_password']}
                                        </Button>
                                    </div>
                                </Form>
                            </div>
                        </Grid>
                    </div>
                </Paper>
            </Grid>
        </div>
    )
}
export default ConfirmUserView;